import { useEffect, useState } from "react";
import { FileLock2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { saveBlob } from "./Bookkeeping";
import { wibTime } from "./ManagerRequests";

const KIND = { FUNDING_ACK: "Pernyataan Risiko", SCHEME_CONFIRM: "Persetujuan Skema", SCHEME_LOCK: "Skema Dikunci" };

const Row = ({ a, testid }) => {
  const [busy, setBusy] = useState(false);
  const dl = async () => {
    setBusy(true);
    try { await saveBlob(`/agreement-archives/${a.id}/pdf`, `${a.code}.pdf`); } catch (e) { toast.error("Gagal mengunduh arsip"); } finally { setBusy(false); }
  };
  return (
    <li className="flex flex-col gap-2 py-2.5 sm:flex-row sm:items-center sm:justify-between" data-testid={`${testid}-${a.id}`}>
      <div className="min-w-0 text-sm">
        <p className="font-semibold text-slate-900 break-words">{KIND[a.kind]} · {a.projectCode || "-"}</p>
        <p className="font-mono text-xs text-emerald-800 break-all" data-testid={`${testid}-code-${a.id}`}>{a.code}</p>
        <p className="text-xs text-slate-500">Disetujui {wibTime(a.sourceAt)}{a.backfilled ? " · dibuat ulang dari catatan sistem" : ""}</p>
      </div>
      <button type="button" disabled={busy} onClick={dl} className="shrink-0 self-start sm:self-center h-9 px-4 rounded-full border border-emerald-800 text-emerald-800 text-sm font-bold disabled:opacity-60" data-testid={`${testid}-dl-${a.id}`}>{busy ? "Mengunduh..." : "Unduh PDF"}</button>
    </li>
  );
};

export const AgreementArchives = ({ contractId, projectId, refreshKey, testid = "archives", title = "Arsip Persetujuan Terkunci", hideEmpty = true }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    const q = new URLSearchParams({ ...(contractId && { contractId }), ...(projectId && { projectId }) }).toString();
    api.get(`/agreement-archives${q ? `?${q}` : ""}`).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [contractId, projectId, refreshKey]);
  if (!items || (hideEmpty && !items.length)) return null;
  return (
    <section className="mb-6 rounded-xl border bg-white p-4 sm:p-5" data-testid={testid}>
      <p className="flex items-center gap-2 font-bold text-slate-900"><FileLock2 className="h-4 w-4 text-emerald-800" />{title}</p>
      <p className="text-xs text-slate-500 mb-2">PDF dengan kode unik dan waktu persetujuan. Dibuat otomatis, tidak dapat diubah atau dihapus.</p>
      {!items.length ? <p className="text-sm text-slate-500" data-testid={`${testid}-empty`}>Belum ada arsip.</p>
        : <ul className="divide-y">{items.map((a) => <Row key={a.id} a={a} testid={testid} />)}</ul>}
    </section>
  );
};
